import { transformObjectKeys } from "@core/utility/common-utils"
import { RecursiveSnakeCaseType, transformFromCamelCaseToSnakeCase, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let loginViaPasswordLoad = (uiBody:LoginViaPasswordUIRequestBody): Observable<LoginViaPasswordAPIRequestBody>=>{



  let apiBody = new LoginViaPasswordAPIRequestBody({data:transformObjectKeys(
    uiBody,
    transformFromCamelCaseToSnakeCase
  )})
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let loginViaPasswordSuccess = (apiBody:LoginViaPasswordAPIResponseBody):LoginViaPasswordUIResponseBody=>{
  let uiBody = new LoginViaPasswordUIResponseBody(transformObjectKeys(
    apiBody.data,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}

export class LoginViaPasswordUIRequestBody {
  constructor(props:Partial<LoginViaPasswordUIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  email:string
  pass:string
}

export class LoginViaPasswordAPIRequestBody {
  constructor(props:Partial<LoginViaPasswordAPIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  data:RecursiveSnakeCaseType<LoginViaPasswordUIRequestBody>
}

export class LoginViaPasswordUIResponseBody {
  constructor(props:Partial<LoginViaPasswordUIResponseBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }

}

export class LoginViaPasswordAPIResponseBody {
  constructor(props:Partial<LoginViaPasswordAPIResponseBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  data:RecursiveSnakeCaseType<LoginViaPasswordUIResponseBody>
}

